import i18next from 'i18next';

import { LANGUAGE_KEYS } from '~constants/languages';

i18next.addResources(LANGUAGE_KEYS.CHILE, 'GiftCardBanner', {
  description: 'Obtén tus Gift Cards por un precio promocional de descuento.'
});
